import { createFileRoute } from "@tanstack/react-router";
import { ParentDashboard } from "@/lib/lazyPages";
import appCss from "@/styles/app.css?url";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/parent-dashboard")({
  head: () => {
    const seo = seoHead({ title: "Parent Hub", noindex: true });
    return { ...seo, links: [...seo.links, { rel: "stylesheet", href: appCss }] };
  },
  component: ParentDashboard,
});
